import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import colours from 'styles/colours';
import {logOut} from 'modules/authentication/actions';

const containerStyles = {
    borderTop: `1px solid ${colours.border.rowDivider}`,
    background: colours.background.listRow.normal,
    flexShrink: 0,
};

const buttonStyles = ({active, focused}) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: '16px 20px 16px 21px',
    background: active ? colours.background.listRow.hover : colours.background.listRow.normal,
    border: 'none',
    borderLeft: active ? `3px solid ${colours.border.primary.highlight}` : '3px solid transparent',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.04em',
    color: active ? colours.border.primary.shadow : colours.font.bodyMuted,
    fontFamily: 'inherit',
    transition: 'background 0.15s ease, border-color 0.15s ease, color 0.15s ease',
    boxSizing: 'border-box',
    outline: focused ? `2px solid ${colours.border.primary.highlight}` : 'none',
    outlineOffset: focused ? '-2px' : '0',
});

const iconStyles = (active) => ({
    fontFamily: '"Material Symbols Outlined Uniportal"',
    flexShrink: 0,
    fontSize: 18,
    lineHeight: 1,
    color: 'inherit',
    fontVariationSettings: `"FILL" ${active ? 1 : 0}`,
    transition: 'font-variation-settings 0.2s',
    userSelect: 'none',
});

export default function SignOutButton({onClose}) {
    const dispatch = useDispatch();
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);
    const active = hovered || focused;

    const handleClick = () => {
        dispatch(logOut());
        onClose();
    };

    return (
        <div style={containerStyles}>
            <button
                onClick={handleClick}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                style={buttonStyles({active, focused})}
            >
                <span className="material-symbols-outlined" aria-hidden="true" style={iconStyles(active)}>
                    logout
                </span>
                Sign out
            </button>
        </div>
    );
}
